import React, { useState } from 'react';
import { Header } from './components/Header';
import { CaseStudyBand } from './components/CaseStudyBand';
import { Footer } from './components/Footer';
import { CaseStudyPage } from './pages/CaseStudyPage';
import { CheckoutCaseStudyPage } from './pages/CheckoutCaseStudyPage';
import { AccountCaseStudyPage } from './pages/AccountCaseStudyPage';
import { PlayPage } from './pages/PlayPage';
import { AboutPage } from './pages/AboutPage';
export function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'case-study' | 'play' | 'about'>('home');
  const [selectedStudyIndex, setSelectedStudyIndex] = useState<number | null>(null);
  const handleViewCaseStudy = (index: number) => {
    setSelectedStudyIndex(index);
    setCurrentPage('case-study');
  };
  const handleBackToHome = () => {
    setCurrentPage('home');
    setSelectedStudyIndex(null);
    window.scrollTo(0, 0);
  };
  const handleNavigatePlay = () => {
    setCurrentPage('play');
    setSelectedStudyIndex(null);
    window.scrollTo(0, 0);
  };
  const handleNavigateAbout = () => {
    setCurrentPage('about');
    setSelectedStudyIndex(null);
    window.scrollTo(0, 0);
  };
  const caseStudies = [{
    title: 'Redesigning the Checkout Experience',
    description: 'Leading end-to-end redesign of the checkout experience across grocery, apparel and beauty e-commerce.',
    year: '2025',
    imagePosition: 'right' as const,
    bgColor: '#F8F6F3',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/k8HoL5wwhEcfoHfV7yTgrP/Checkout_cover.png'
  }, {
    title: 'Creating a design system to serve millions of Canadians',
    description: 'Built and maintained a comprehensive design system serving 12 product teams, establishing consistent patterns across web and mobile platforms.',
    year: '2024',
    imagePosition: 'left' as const,
    bgColor: '#F8F6F3',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/iwosvubqzXhFos5bGGFxg3/DS_sizzle_cover.png'
  }, {
    title: 'Centralizing Account Management',
    description: 'Unified fragmented account systems while navigating privacy regulations, stakeholder dynamics, and legacy technical constraints.',
    year: '2023',
    imagePosition: 'right' as const,
    bgColor: '#F8F6F3',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/tsmPeseT1k9HS7eN5ennR1/One_account_cover.png'
  }];
  return <div className="min-h-screen w-full bg-[#F8F6F3] text-[#1A1A1A]" data-id="element-0">
      <Header onNavigateHome={handleBackToHome} onNavigatePlay={handleNavigatePlay} onNavigateAbout={handleNavigateAbout} activePage={currentPage} data-id="element-1" />

      <div className="md:ml-16 lg:ml-56 pb-16 md:pb-0" data-id="element-2">
        {currentPage === 'home' && <>
            <main id="work" data-id="element-3">
              {caseStudies.map((study, index) => <CaseStudyBand key={index} index={index} {...study} onViewCaseStudy={() => handleViewCaseStudy(index)} data-id="element-4" />)}
            </main>
            <Footer data-id="element-5" />
          </>}

        {currentPage === 'case-study' && <>
            {selectedStudyIndex === 0 ? <CheckoutCaseStudyPage onBack={handleBackToHome} onNext={() => handleViewCaseStudy(1)} nextLabel="Design System" data-id="element-6" /> : selectedStudyIndex === 1 ? <CaseStudyPage onBack={handleBackToHome} onNext={() => handleViewCaseStudy(2)} nextLabel="Account Management" data-id="element-7" /> : selectedStudyIndex === 2 ? <AccountCaseStudyPage onBack={handleBackToHome} onNext={() => handleViewCaseStudy(3)} nextLabel="Forge Redesign" data-id="element-8" /> : <CaseStudyPage onBack={handleBackToHome} onNext={() => handleViewCaseStudy(0)} nextLabel="Checkout Experience" data-id="element-9" />}
          </>}

        {currentPage === 'play' && <PlayPage data-id="element-10" />}
        {currentPage === 'about' && <AboutPage onBack={handleBackToHome} data-id="element-11" />}
      </div>
    </div>;
}